export default __webpack_public_path__ + "static/media/fra.74297680.svg";